import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { Title } from '../../../shared/ModalComponents';
import defaultAttrs from '../../../lib/utils/defaultAttrs';

export const OuterSection = styled.section`
  background: ${themeGet('colors.white')};
  display: flex;
  flex-direction: column;
  font-family: 'Montserrat', sans-serif;
  position: relative;
  border-radius: 8px;
  width: 100%;
  border: 1px solid ${themeGet('colors.black.10')};
  padding: 16px 24px;

  &:last-child {
    margin: 0 0 0 24px;
  }
`;

export const OuterSectionHeading = styled.h2`
  color: ${themeGet('colors.black.100')};
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.1px;
  text-align: left;
  margin: 0;
`;

export const OuterSectionParagraph = styled.p`
  color: ${themeGet('colors.black.100')};
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  margin: 0 0 0 auto;
`;

export const StyledSection = styled.section`
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  padding: 8px 0;

  &:first-child {
    padding: 0 0 10px;
  }

  &:last-child {
    border-bottom: 0px;
    padding: 8px 0 0;
  }
`;

export const SectionHeading = styled.h2`
  color: ${themeGet('colors.black.100')};
  font-size: 13px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.1px;
  margin: 0;
`;

export const SectionParagraph = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.1px;
  text-align: left;
  margin: 0px;
`;

export const BulletPoint = styled(SectionParagraph).attrs(
  defaultAttrs({ as: 'li' }),
)`
  display: list-item;
  list-style-type: disc;
  list-style-position: inside;
`;

export const StyledLink = styled.a`
  color: ${themeGet('colors.primary.100')};
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
`;

export const StyledDivButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const SubmitButton = styled.input`
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.2px;
  padding: 11px 24px;
  color: white;
  background: ${themeGet('colors.primary.100')};

  &:disabled {
    background: ${themeGet('colors.black.5')};
    color: ${themeGet('colors.black.60')};
    border: 1px solid ${themeGet('colors.black.20')};
    border-radius: 8px;
  }
`;

export const StyledText = styled.p`
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.1px;
  color: ${themeGet('colors.black.80')};
  margin-left: 24px;
  margin-bottom: 10px;
`;

export const AirboEmail = styled.span`
  color: ${themeGet('colors.primary.100')};
`;

export const TitleRow = styled.div`
  display: flex;
  margin: 0 0 16px;
`;

export const Heading = styled(Title)`
  margin: 0;
`;

export const CloseIcon = styled.img`
  cursor: pointer;
  padding-left: 10px;
`;
